//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import proseText from '~/mixins/proseText'
import layout from '~/mixins/layout'
import share from '~/mixins/share.js'

export default {
  mixins: [proseText, layout, share],
  inheritAttrs: false,
  props: {
    type: {
      type: String,
      default: 'user',
    },
    id: {
      type: String,
      required: true,
    },
    avatar: {
      type: Object,
      default() {},
    },
    firstName: {
      type: String,
      default: '',
    },
    lastName: {
      type: String,
      default: '',
    },
    title: {
      type: String,
      default: '',
      required: true,
    },
    subline: {
      type: String,
      default: '',
    },
    whatsappNumber: {
      type: String,
      default: '',
    },
    videoLink: {
      type: String,
      default: '',
    },
    avatarForVideo: {
      type: String,
      default: '',
    },
    videoThumbnail: {
      type: Object,
      default() {},
    },
    shortDescription: {
      type: String,
      default: '',
    },
    aboutMentor: {
      type: String,
      default: '',
    },
    location: {
      type: Object,
      default() {},
    },
    languages: {
      type: Array,
      default() {},
    },
    implantType: {
      type: Array,
      default() {},
    },
    stats: {
      type: Array,
      default() {},
    },
    text: {
      type: String,
      default: '',
    },
    nextMentor: {
      type: Object,
      default() {},
    },
    hearingJourneyNew: {
      type: Array,
      default() {},
    },
    forumId: {
      type: [Number, String],
      default: '',
    },
    forum: {
      type: Object,
      default() {
        return {
          topics: [],
          posts: [],
          groups: [],
        }
      },
    },
  },
  data() {
    return {
      itemsBreadcrumb: [],
      activeHeading: null,
      manualScrollInProgress: false,
      userSelectedHeading: null,
      headingTexts: [],
      defaultUrl: process.env.baseUrl
        ? process.env.baseUrl + this.$route.path
        : window.location.href,
      defaultTitle: this.$route.meta?.title,
    }
  },
  computed: {
    readingTime() {
      return this.$readingTime(this.text)
    },
  },
  mounted() {
    this.itemsBreadcrumb = [
      { title: 'Home', slug: '/' },
      { title: 'Find Support', slug: 'find-support' },
      {
        title: 'Connect with a mentor',
        slug: 'find-support/connect-with-a-mentor',
      },
      { title: this.firstName, slug: '' },
    ]

    this.headingTexts = this.createListHeadings(this.text)
    this.updateObserver()
  },
  methods: {
    updateObserver() {
      this.$nextTick(() => {
        this.observeHeadings()
      })
    },

    observeHeadings() {
      if (!('IntersectionObserver' in window)) {
        console.warn('IntersectionObserver não é suportado neste navegador.')
        return
      }

      const observer = new IntersectionObserver(
        (entries) => {
          // Filtrar as entradas que estão intersectando
          const intersectingEntries = entries.filter(
            (entry) => entry.isIntersecting
          )

          if (intersectingEntries.length === 0) {
            return
          }

          // Se a rolagem manual está em andamento
          if (this.manualScrollInProgress) {
            // Verificar se o heading observado é o que o usuário selecionou
            const userHeadingEntry = intersectingEntries.find((entry) => {
              return (
                entry.target.textContent.trim() === this.userSelectedHeading
              )
            })

            if (userHeadingEntry) {
              // O heading selecionado pelo usuário está visível
              this.activeHeading = this.userSelectedHeading
              // Aguardamos o fim da rolagem no método `scrollToHeadingByText`, portanto não redefinimos `manualScrollInProgress` aqui
            }
            // Ignorar outras entradas enquanto a rolagem manual está em andamento
            return
          }

          // Encontrar a entrada com o maior intersectionRatio
          const mostVisibleEntry = intersectingEntries.reduce(
            (prev, current) => {
              return prev.intersectionRatio > current.intersectionRatio
                ? prev
                : current
            }
          )

          const entryTextContent = mostVisibleEntry.target.textContent.trim()

          // Atualizar activeHeading
          this.activeHeading = entryTextContent
        },
        {
          root: null,
          rootMargin: '-140px 0px -75% 0px',
          threshold: 0,
        }
      )

      this.headingTexts.forEach((h) => {
        const headingEl = this.findHeadingElementByText(h)
        if (headingEl) {
          observer.observe(headingEl)
        }
      })
    },

    createListHeadings(htmlContent) {
      if (!htmlContent) return []
      const parser = new DOMParser()
      const doc = parser.parseFromString(htmlContent, 'text/html')
      const headingElements = doc.querySelectorAll('h1, h2, h3, h4')
      const headingsText = []

      headingsText.push(this.$translation('myHearingJourney')) // add first title
      headingElements.forEach((heading) => {
        headingsText.push(heading.textContent.trim())
      })
      return headingsText
    },
    onHeadingSelected(headingText) {
      this.activeHeading = headingText
      this.manualScrollInProgress = true
      this.userSelectedHeading = headingText

      this.$nextTick(() => {
        this.scrollToHeadingByText(headingText)
      })
    },
    scrollToHeadingByText(headingText) {
      const headingEl = this.findHeadingElementByText(headingText)
      if (headingEl) {
        headingEl.scrollIntoView({ behavior: 'smooth', block: 'start' })
        this.waitForScrollEnd().then(() => {
          // Desativa a rolagem manual após a rolagem terminar
          this.manualScrollInProgress = false
          this.userSelectedHeading = null
        })
      } else {
        console.warn(
          `Cabeçalho com texto "${headingText}" não encontrado no DOM.`
        )
      }
    },
    waitForScrollEnd() {
      return new Promise((resolve) => {
        let isScrolling
        const onScroll = () => {
          window.clearTimeout(isScrolling)
          isScrolling = setTimeout(() => {
            window.removeEventListener('scroll', onScroll)
            resolve()
          }, 150)
        }
        window.addEventListener('scroll', onScroll)
      })
    },
    findHeadingElementByText(headingText) {
      const headingElements =
        this.$refs.runtimeContainer.querySelectorAll('h1, h2, h3, h4')
      return Array.from(headingElements).find(
        (el) => el.textContent.trim() === headingText.trim()
      )
    },
  },
}
